import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UserSessionService } from './user-session.service';
import { COMPANY_ID } from '../global-constants';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PagetitleService {

  constructor(private titleService: Title, private userSessionService: UserSessionService) { }

  public setPageTitle(titleBeginning: string){
    let titleCompany: string;
    let fullTitle: string;

    if(this.userSessionService.data.companyId == COMPANY_ID.NM){
      titleCompany = 'Northwestern Mutual';
    } else {
      titleCompany = 'The Standard';
    }

    fullTitle = titleBeginning + ' | ' + titleCompany;
    this.titleService.setTitle(fullTitle);
  }

  private yiPolicy = new BehaviorSubject(false);
  public isYiPolicy = this.yiPolicy.asObservable();

  setIsYiPolicy(message: boolean) {
    this.yiPolicy.next(message)
  }
}
